import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton, WixIcons } from '../../../../components/common';
import { BiAddMediaClickOrigin } from '../../../../constants/Bi';
import { ModalName } from '../../../../constants/ModalName';
import { useTrackAddMediaButtonClickAnalytics } from '../../../../utils/hooks/bi/useTrackAddMediaButtonClickAnalytics';
import { useModalHandlersAndOptions } from '../../../../utils/hooks/useModal';
import { useStorageQuotaAwareHandler } from '../../../../utils/hooks/storageQuota/useStorageQuotaAwareHandler';
import { StorageQuotaUseCase } from '../../../../utils/hooks/storageQuota/useStorageQuotaAwareHandler/StorageQuotaUseCase';
import { isRootFolder } from '../../../../utils/media-manager-sdk/items';
import { IOuter } from '../EmptyState.types';

export const SiteFilesNewDnDButton: FC<IOuter> = ({ currentFolder }) => {
  const { trackAddMediaButtonClickStartAdding, trackAddMediaButtonClickEmptyFolderOrFilter } =
    useTrackAddMediaButtonClickAnalytics();

  const storageQuotaAware = useStorageQuotaAwareHandler();
  const openFilesImporterModal = storageQuotaAware(
    useModalHandlersAndOptions(ModalName.FilesImporter).openModal,
    StorageQuotaUseCase.UPLOAD,
  );

  const handleClick = useCallback(() => {
    const isRoot = isRootFolder(currentFolder);

    openFilesImporterModal({
      openedFrom: isRoot ? BiAddMediaClickOrigin.StartAdding : BiAddMediaClickOrigin.EmptyFolder,
    });
    isRoot ? trackAddMediaButtonClickStartAdding() : trackAddMediaButtonClickEmptyFolderOrFilter();
  }, [
    currentFolder,
    openFilesImporterModal,
    trackAddMediaButtonClickStartAdding,
    trackAddMediaButtonClickEmptyFolderOrFilter,
  ]);

  return (
    <TextButton size="small" as="a" onClick={handleClick} prefixIcon={<WixIcons.Add />} dataHook="add-media-button">
      <FormattedMessage id="empty-state.folder-subtitle.add-media" />
    </TextButton>
  );
};
